export default {
  state: {
    currentTab: 0,
    currentTabValue: "content_optimisation",
    tabs: [{
      text: "SKU level",
      value: "content_optimisation",
      activeBg: "var(--market-50)",
      activeColor: "var(--market-800)",
      event: "contentSkuLevelTabOpened"
    }, {
      text: "Parent level",
      value: "content_optimisation_with_parent",
      activeBg: "var(--market-50)",
      activeColor: "var(--market-800)",
      isNewTab: true,
      event: "contentParentLevelTabOpened"
    }]
  },
  mutations: {
    seoSetCurrentTab(state, payload) {
      state.currentTab = payload;
      state.currentTabValue = state.tabs[payload].value;
    }
  },
  getters: {
    seoGetTab(state) {
      return () => state.currentTab;
    },
    seoGetTabValue(state) {
      return () => state.tabs[state.currentTab].value;
    }
  },
  actions: {
    seoSetTab({
      commit
    }, tab) {
      commit('seoSetCurrentTab', tab);
    }
  }
};